// Shared CDN origin and URL joining for static and catalog-backed assets.
export const CDN_BASE_URL = 'https://assets.airheadgames.com';
export function joinCdnUrl(path, baseUrl = CDN_BASE_URL) {
    const normalizedPath = path.replace(/^\/+/, '');
    if (!baseUrl) {
        return `/${normalizedPath}`;
    }
    return `${baseUrl.replace(/\/$/, '')}/${normalizedPath}`;
}
//# sourceMappingURL=cdn.js.map